import React, { useState } from 'react';
import { useListEditor } from '../hooks/useListEditor';

export default function TrainingAccordionEditor({ items, onChange }) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const { editIndex, select, clear, isEditing } = useListEditor(() => {
    setTitle('');
    setBody('');
  });

  const handleSelectItem = (i) => {
    const item = items[i];
    setTitle(item.title);
    setBody(item.body);
    select(i);
  };

  const handleSave = () => {
    if (!title.trim()) return;
    if (isEditing) {
      onChange(items.map((it, i) => i === editIndex ? { ...it, title: title.trim(), body: body.trim() } : it));
    } else {
      onChange([...items, { _id: crypto.randomUUID(), title: title.trim(), body: body.trim() }]);
    }
    clear();
  };

  const handleRemove = (e, i) => {
    e.stopPropagation();
    onChange(items.filter((_, idx) => idx !== i));
    if (editIndex === i) clear();
  };

  return (
    <>
      <div className="content-editor-add-form mb-3">
        <div className="form-group mb-2">
          <label className="form-label">Titulo</label>
          <input type="text" className="form-control" value={title}
            onChange={(e) => setTitle(e.target.value)} placeholder="Titulo del item" />
        </div>
        <div className="form-group mb-2">
          <label className="form-label">Contenido</label>
          <textarea className="form-control" rows="3" value={body}
            onChange={(e) => setBody(e.target.value)} placeholder="Texto..." />
        </div>
        <div className="d-flex gap-2">
          <button type="button" className="btn btn-secondary" onClick={handleSave}>
            {isEditing ? 'Guardar cambios' : 'Añadir item'}
          </button>
          {isEditing && (
            <button type="button" className="btn btn-outline-secondary" onClick={clear}>
              Cancelar
            </button>
          )}
        </div>
      </div>
      {items.length === 0 ? (
        <div className="blocks-list-empty">Sin items aún</div>
      ) : (
        <div className="content-editor-list">
          {items.map((item, i) => (
            <div key={item._id || i} className={`content-editor-list-item ${editIndex === i ? 'selected' : ''}`}
              onClick={() => handleSelectItem(i)} style={{ cursor: 'pointer' }}>
              <span className="blocks-list-index">{i + 1}</span>
              <span className="blocks-list-name">{item.title}</span>
              <button type="button" className="blocks-list-remove" onClick={(e) => handleRemove(e, i)}>x</button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
